module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.f61a4eb2.ttf";